export default __webpack_public_path__ + "static/sprite-6bdedf036aa617ed0976b2e626ae0551.svg";